<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-sharing"
      scrollable
      :title="`Compartilhar Pasta ${folderName}`"
      size="lg"
    >
      <div class="form-group row mt-2 mb-5">
        <div class="col-12">
          <h6>Compartilhar com</h6>
        </div>
        <div class="col-12">
          <div class="input-group">
            <b-form-input v-model="form.email.value" placeholder="Digite o e-mail do usuário e clique em compartilhar" />
            <span class="input-group-addon" style="background-color: #006a5b; color: #f5f5f5; border-left: 1px solid #d9d9d9" @click="onSharing"><i class="fas fa-share-alt-square pr-2"></i> Compartilhar</span>
          </div>
        </div>
      </div>

      <div class="row mt-2 mb-4">
        <div class="col-12">
         <h6>Lista de usuário com acesso</h6>
          <span class="pointer" @click="onGetAllShared" style="display: block;position: relative;text-align: right;top: -28px;margin-right: 5px;"><i class="fas fa-sync-alt text-third"></i></span>
        </div>
        <div class="col-12">
          <div class="list-users pt-3">
            <ul v-for="(objShared, index) in listShared" :key="index">
              <li style="list-style-type: none; display: block; position: relative; left:-20px">
                <div class="row pt-1 pl-2">
                  <div class="col-10">
                    <i class="fas fa-user text-third"></i>
                    <strong class="text-third pl-2">{{ objShared.usuario.pessoa.nome }} <small>({{objShared.usuario.pessoa.email}})</small></strong>
                  </div>
                  <div class="col-2 text">
                    <span class="ml-2" v-b-tooltip.hover title="Excluir">
                      <b-dropdown variant="link" size="sm" no-caret>
                        <template slot="button-content">
                          <i class="fas fa-trash-alt text-third icone-grid"></i><span class="sr-only">{{ $lang.Common.Buttons.Delete }}</span>
                        </template>
                        <b-dropdown-header><strong>{{ $lang.Common.ConfirmDelete }}</strong></b-dropdown-header>
                        <b-dropdown-item href="javascript:void(0);" @click="onDelete(objShared.id)">{{ $lang.Common.Yes }}</b-dropdown-item>
                        <b-dropdown-item href="javascript:void(0);">{{ $lang.Common.No }}</b-dropdown-item>
                      </b-dropdown>
                    </span>
                  </div>
                </div>
                <hr>
              </li>
            </ul>
            <div class="text-center mt-5 pt-3" v-if="listShared === null || listShared.length === 0">
              <span style="font-size: 12px; font-weight: normal; color: #a9a9a9;">Não há compartilhamento nessa pastas!</span>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-default btn-sm"  v-b-tooltip.hover :title="'Fechar'" @click.prevent="hideModal"><i class="fas fa-times-circle"></i> Fechar</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import Gedcompartilhamento from '@/shared/http/repositories/ged/gedcompartilhamento.js'
import { loading, toast } from '@/shared/utils/UIHelper'

export default {
  name: 'ModalSharing',
  mixins: [ActionsForm],
  data () {
    return {
      item: null,
      shared: [],
      data: null,
      form: {
        email: {
          value: '',
          error: null
        }
      }
    }
  },
  computed: {
    folderName () {
      return this.item ? this.item.nome : ''
    },
    listShared () {
      return this.shared ? this.shared : []
    }
  },
  methods: {
    showModal (obj) {
      this.onClear()
      this.$refs['modal-sharing'].show()
      this.item = obj
      this.$nextTick(() => {
        this.onGetAllShared()
      })
    },
    hideModal () {
      this.$refs['modal-sharing'].hide()
    },
    onGetAllShared () {
      if (this.item) {
        loading.push()
        Gedcompartilhamento.GetAllByMenu(this.item.id, 100, 0)
          .then((response) => {
            loading.pop()
            this.shared = response.data.content
          })
          .catch(this.onException)
      }
    },
    onSharing () {
      if (this.form.email.value === '') {
        toast.warning('<strong>ATENÇÃO!</strong> Informe o e-mail do usuário para compartilhar a pasta!')
        return false
      }
      loading.push()
      let dataSharing = {
        email: this.form.email.value,
        menuId: this.item.id
      }
      Gedcompartilhamento.Share(dataSharing)
        .then((response) => {
          loading.pop()
          this.onGetAllShared(this.item.id)
          this.form.email.value = ''
          toast.success('Compartilhamento realizado com sucesso!', 'GED - Compartilhamento')
          this.onGetAllShared()
        })
        .catch(this.onException)
    },
    onDelete (id) {
      loading.push()
      Gedcompartilhamento.Delete(id)
        .then((response) => {
          loading.pop()
          toast.success('Compartilhamento excluído com sucesso!', 'GED - Compartilhamento')
          this.onGetAllShared()
        })
        .catch(this.onException)
    }
  }
}
</script>
<style>
  .list-users {
    height: 250px;
    overflow-y: auto;
    scrollbar-width: thin;
    background-color: #fdfdfd;
    border: solid 1px #efefef;
    border-radius: 5px;
  }
  span.input-group-addon {
    cursor: pointer;
    max-height: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/ged/rightcontent/components/modalsharing.vue